module.exports = "/images/vendor/flag-icon-css/flags/1x1/ie.svg?798a56e04350344c5937927fea36fabc";